import store from '../store' 
import router from '@/router'
export const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['userStore/isAuthenticated']) {
    next()
    return
  }
  router.push("/");
}

export const ifAuthenticated = (to, from, next) => {
  if (store.getters['userStore/isAuthenticated']) {
    next()
    return
  }
  router.push("/login");
}